module.exports = __webpack_public_path__ + "img/card.fea78442.png";